const convertArg = arg => {
	if (typeof arg === 'number') {
		const a = Math.max(arg, 0);
		return Number.isFinite(a) ? String(a) : '0';
	}
	return String(arg);
};

/**
 * Pad a date or time segment to 2-digits
 *
 * @note This can be called on a YYYY segment with no change since that's more than 2 digits
 *
 * @param {string|number} [segment=0] The segment to pad
 * @returns {string} The segment padded with leading zeroes
 */
export const padDateTimeSegment = (segment = 0) => convertArg(segment).padStart(2, '0');
